require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-using-custom-initializers-in-swift.json") })
        }
      }, "path---blog-using-custom-initializers-in-swift");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-using-custom-initializers-in-swift!./.cache/json/blog-using-custom-initializers-in-swift.json
// module id = 1128
// module chunks = 231608221292675